import {Span} from '@cindedi/ui/components/Span';

export function Copyright(props: UI.Span.Props) {
  return (
    <Span {...props}>
      © 2012 - {new Date().getFullYear()} - Todos os direitos reservados para a equipe do CINDEDI
    </Span>
  );
}
